import {Refresh} from '@mui/icons-material';
import {
  ComponentProps,
  createContext,
  FC,
  ReactElement,
  useContext,
  useState
} from 'react';

// Define the interface with both bannerDetails and setBannerDetails
interface RefreshLeftMenuInterface {
  refreshLeftMenu: boolean; // Replace `any` with your actual type
  setRefreshLeftMenu: (details: boolean) => void; // Adjust `any` to match the type of bannerDetails
}

// Create the context with a default value
const RefreshLeftMenuContext = createContext<RefreshLeftMenuInterface>({
  refreshLeftMenu: false,
  setRefreshLeftMenu: () => {} // Default no-op function
});

// Hook to use the RefreshLeftMenu context
export const useRefreshLeftMenu = (): RefreshLeftMenuInterface =>
  useContext(RefreshLeftMenuContext);

// Provider component for RefreshLeftMenuContext
const RefreshLeftMenuProvider = ({
  children
}: ComponentProps<FC<any>> & {children: ReactElement}): JSX.Element => {
  const [refreshLeftMenu, setRefreshLeftMenu] = useState<boolean>(false); // Define the state

  return (
    <RefreshLeftMenuContext.Provider
      value={{refreshLeftMenu, setRefreshLeftMenu}}>
      {children}
    </RefreshLeftMenuContext.Provider>
  );
};

export default RefreshLeftMenuProvider;
